import { Injectable } from '@angular/core';
import { first } from 'lodash';
import { UserWizardService } from '../../services/user/user.wizard.service';
import {
  ApiService,
  InputDatastoreService,
  CountryListService,
  DialogService,
  UserService,
  ValuesExchangeProvider
} from '@nrwl/common-lib';

@Injectable()
export class UpdateUserPasswordService extends UserWizardService {
  constructor(
    apiService: ApiService,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService,
    readonly userService: UserService,
    valuesExchange: ValuesExchangeProvider
  ) {
    super(
      apiService,
      inputDatastoreService,
      countryListService,
      dialogService,
      userService,
      valuesExchange
    );
  }

  //------------------------------------------------ Wizard control ----------------------------------------------------

  onFinish() {
    this.dataUrl = '/ims/v2/users/' + this.defaultParamsById.userId + '/settings/password';
    const responseProcessed = this._saveWizardData();
    responseProcessed.subscribe(() => {
      this.currentStep = this.finishingStep;
      if (!this.requestFailed) {
        this.successMessage = 'User password updated successfully';
      }
    });
    return responseProcessed;
  }

  _handleErrorResponse(errorResponse) {
    this.errorMessage = 'User password was not updated';

    if (errorResponse && errorResponse.error) {
      const errorMessages = errorResponse.error.errors;
      this.errorDescription = first(errorMessages);
    }
  }
}
